module.exports = function () {
  return "<div class=\"poker-sidebar\" id=\"poker-sidebar\"></div>";
};